import { query, mutation } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    reports: [],
    questionReports: [],
  },
  mutations: {
    SET_REPORTS(state: any, reports: any) {
      state.reports = reports;
    },
    SET_QUESTION_REPORTS(state: any, questionReports: any) {
      state.questionReports = questionReports;
    },
    SET_SOLUTION_REPORTS(state: any, solutionReports: any) {
      state.solutionReports = solutionReports;
    },
  },
  getters: {
    filterQuestionReports: (state: any) => (userId: number) => {
      if (userId) {
        return state.questionReports.filter((questionReport: any) => {
          return questionReport.userId == userId;
        });
      } else {
        return state.questionReports;
      }
    },
    filterReports: (state: any) => (userId: number) => {
      if (userId) {
        return state.reports.filter((report: any) => {
          return report.questionByQuestionId.userId == userId;
        });
      } else {
        return state.reports;
      }
    },
    filterSolutionReports: (state: any) => (userId: number) => {
      if (userId) {
        return state.solutionReports.filter((solutionReport: any) => {
          return solutionReport.userId == userId;
        });
      } else {
        return state.solutionReports;
      }
    },
  },
  actions: {
    async PULL_REPORTS({ commit }: any, { currentPage, showDone }: any) {
      currentPage = currentPage || 0;
      if (showDone === undefined) {
        showDone = true;
      }
      let condition = '';
      if (showDone === false) {
        condition = 'condition: {done: false}';
      }
      let resultsPerPage = 100;
      let offset = resultsPerPage * currentPage;
      let response = await query(
        `query getAllReportsDexAdmin($resultsPerPage: Int, $offset: Int){
        allReports(first: $resultsPerPage, offset: $offset, orderBy: ID_DESC, ${condition}){
          nodes {
            id
            kind
            description
            done
            questionByQuestionId {
              id
              userId
            }
            solutionBySolutionId {
              id
              userId
              questionId
            }
          }
        }
      }`,
        {
          resultsPerPage,
          offset,
        },
      );
      let reportsNodes = response.data.allReports;
      if (reportsNodes) {
        commit('SET_REPORTS', reportsNodes.nodes);
      }
    },
    async PULL_QUESTION_REPORTS({ commit }: any, { currentPage }: any) {
      currentPage = currentPage || 0;
      let resultsPerPage = 100;
      let offset = resultsPerPage * currentPage;
      let response = await query(
        `query getQuestionsByReportsDexAdmin($resultsPerPage: Int, $offset: Int) {
          getQuestionsByReports(first: $resultsPerPage, offset: $offset) {
            nodes {
              id
              userId
              numberOfReports
              content
            }
          }
        }`,
        {
          resultsPerPage,
          offset,
        },
      );
      commit('SET_QUESTION_REPORTS', response.data.getQuestionsByReports.nodes);
    },
    async PULL_SOLUTION_REPORTS({ commit }: any, { currentPage }: any) {
      currentPage = currentPage || 0;
      let resultsPerPage = 100;
      let offset = resultsPerPage * currentPage;
      let response = await query(
        `
      query getSolutionsByReportsDexAdmin($resultsPerPage: Int, $offset: Int) {
        getSolutionsByReports(first: $resultsPerPage, offset: $offset) {
          nodes {
            id
            userId
            numberOfReports
            content
            questionId
          }
        }
      }`,
        {
          resultsPerPage,
          offset,
        },
      );
      commit('SET_SOLUTION_REPORTS', response.data.getSolutionsByReports.nodes);
    },
    async TOGGLE_REPORT_DONE({ commit }: any, data: any) {
      let reportId = data.reportId;
      let newState = data.newState;
      let response = await mutation(
        `mutation dexAdminUpdateReportById($reportId: Int!, $newState: Boolean) {
          updateReportById(input: {
            id: $reportId,
            reportPatch: {
              done: $newState
            }
          }) {
            report {
              id
              done
            }
          }
        }`,
        {
          reportId: +reportId,
          newState,
        },
      );
      if (response.data.updateReportById.report.done != newState) {
        //TODO error message
      }
    },
    async SOLVE_MULTIPLE_REPORTS({ commit }: any, reports: any) {
      let response = await mutation(
        `mutation solveMultipleReports {
          ${reports.map(
            (
              report: any,
              index: number,
            ) => `report${index}: updateReportById(input: {
              id: ${report.id},
              reportPatch: {
                done: true
              }
            }) {
              report {
                id
              }
            }`,
          )}
        }`,
      );
    },
  },
};
